/**
 * VIB-642 PR 6.4: UptimeRobot-info-kort.
 *
 * Statisk lenke til UptimeRobot-dashboardet + BetterStack status-side.
 * Vi har ingen API-integrasjon i klienten fordi tokenene må ligge i edge
 * function-secrets, ikke i bundle.
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";

const UPTIMEROBOT_DASHBOARD_URL = "https://uptimerobot.com/dashboard";

export function UptimeRobotInfoCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Uptime</CardTitle>
        <p className="text-sm text-muted-foreground">
          HTTP + keyword-monitor på frontend og <code className="font-mono text-xs">/api/health</code>.
          Sjekk-intervall: 5 min.
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-sm">
          <div className="flex items-baseline justify-between border-b pb-2">
            <span className="text-muted-foreground">Monitorer</span>
            <span>Sølvrev Frontend, Sølvrev API Health</span>
          </div>
          <div className="flex items-baseline justify-between border-b py-2">
            <span className="text-muted-foreground">Varsling</span>
            <span>
              <code className="font-mono text-xs">#vibbing-alerts</code>
            </span>
          </div>
          <div className="flex items-baseline justify-between pt-2">
            <span className="text-muted-foreground">Status-side</span>
            <span className="text-muted-foreground">BetterStack (settes opp manuelt)</span>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 pt-2">
          <Button asChild variant="default" size="sm">
            <a
              href={UPTIMEROBOT_DASHBOARD_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SrIcon name="external-link" size={14} className="mr-1.5" />
              UptimeRobot dashboard
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
